module.exports = __webpack_public_path__ + "media/4x3/in-e4ab7bd0.svg";